module.exports = __webpack_public_path__ + "static/media/thermomix.f7c58809.svg";